import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { processGoogleCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Get session_id from URL fragment
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get("session_id");

      if (sessionId) {
        try {
          await processGoogleCallback(sessionId);
          // Clear the hash from URL and navigate to dashboard
          window.history.replaceState(null, "", window.location.pathname);
          navigate("/", { replace: true });
        } catch (error) {
          console.error("Google auth error:", error);
          navigate("/login", { replace: true });
        }
      } else {
        // No session_id, redirect to login
        navigate("/login", { replace: true });
      }
    };

    processAuth();
  }, [navigate, processGoogleCallback]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-[#547d91] animate-spin mx-auto mb-4" />
        <p className="text-slate-600">Signing you in...</p>
      </div>
    </div>
  );
}
